import { z } from "zod";

export const ConstructionType = z.enum([
  "ResidentialSFD",
  "ResidentialCondos",
  "ResidentialAttached",
  "Commercial",
]);

export type ConstructionTypeEnum = z.infer<typeof ConstructionType>;

export const ConstructionTypeDisplayName: Record<ConstructionTypeEnum, string> =
  {
    [ConstructionType.enum.ResidentialSFD]: "Residential - SFD",
    [ConstructionType.enum.ResidentialCondos]: "Residential - Condos",
    [ConstructionType.enum.ResidentialAttached]: "Residential - Attached",
    [ConstructionType.enum.Commercial]: "Commercial",
  };
